import React, { useState, useEffect } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { X, Camera, AlertTriangle } from 'lucide-react';

const READER_ID = 'kiosk-qr-reader';

export default function QrScannerModal({ onResult, onClose }) {
  const [error, setError] = useState('');

  useEffect(() => {
    const scanner = new Html5Qrcode(READER_ID);
    let stopped = false;

    const stop = () =>
      scanner
        .stop()
        .then(() => scanner.clear())
        .catch(() => {});

    scanner
      .start(
        { facingMode: 'environment' },
        { fps: 10, qrbox: { width: 260, height: 260 } },
        (decoded) => {
          if (stopped) return;
          stopped = true;
          stop().finally(() => onResult(decoded));
        },
        () => {}
      )
      .catch((e) => setError(e?.message || 'Could not start the camera on this device.'));

    return () => {
      if (!stopped) stop();
    };
  }, [onResult]);

  return (
    <div className="fixed inset-0 z-50 bg-black/85 flex items-center justify-center p-6">
      <div className="w-full max-w-xl border border-white/10 bg-[#111115]">
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <div className="flex items-center gap-2.5">
            <Camera className="w-4 h-4 text-primary" />
            <p className="text-white font-bold text-sm tracking-widest">SCAN BOOKING QR CODE</p>
          </div>
          <button onClick={onClose} className="text-white/50 hover:text-white p-2">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5">
          <div id={READER_ID} className="w-full bg-black/60 border border-white/10 overflow-hidden" />
          {error ? (
            <div className="flex items-start gap-2.5 mt-4 border border-red-500/30 bg-red-500/5 px-4 py-3">
              <AlertTriangle className="w-4 h-4 text-red-400 mt-0.5 shrink-0" />
              <p className="text-red-300 text-xs leading-relaxed">{error}</p>
            </div>
          ) : (
            <p className="text-white/40 text-xs mt-4 text-center">
              Hold the customer's booking confirmation QR inside the frame.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}